jQuery(document).ready(function($) {    
  "use strict";
  // FOR MOBILE MENU
  if($(window).width() < 1281) {       
    var phrases = [];

    // Move Nav as Mobile Nav
    $("nav.dt-sc-flex-space-between").each(function() {

      var d = $(this).data('menu'),                    
          c = $(this).find('ul[data-menu="' + d + '"]').clone().removeClass('dt-nav'),
          m = $('body').find('.mobile-menu[data-menu="' + d + '"]');        
      // To Remove animation classes
      $('[data-animation]', c).each(function(ix, ele) {
        var $classes = $(ele).attr("class"),
            $animation = $(ele).attr("data-animation");

        $classes = $classes.replace($animation, '');
        $(ele).attr("class", $classes);
      });

      c.prependTo(m);
    });

    mobileTrigger();

    // Closing Mobile Nav
    $('li.close-nav').on('click', function(event) {
      closeMobNav();
    });

    $('body > .mobile-menu-overlay').on('click', function(event) {
      closeMobNav();
    });

    // Sub Menu in Mobile Menu
    $('.menu-item-has-children > a').on('click', function(event) {

      if ($('body').hasClass('nav-is-visible')) {
        event.preventDefault();
        var a = $(this).clone();
        $(this).next('.sub-menu-block').find('.see-all').html(a);
      }

      var selected = $(this);                
      if (selected.next('div.sub-menu-block').hasClass('is-hidden')) {          
        selected.addClass('selected').next('div.sub-menu-block').removeClass('is-hidden');
      } else {          
        selected.removeClass('selected').next('div.sub-menu-block').addClass('is-hidden');
      }
    });

    // Go Back in Mobile Menu
    $('.go-back').on('click', function() {
      $(this).parent('div.sub-menu-block').addClass('is-hidden');
    });


  }

  // FOR DESKTOP MENU
  if($(window).width() > 1280) {
    
    jQuery('.menu-item-has-children > a').mouseenter(function(e) {
      var selected = $(this);
      if (selected.next('div.sub-menu-block').hasClass('is-hidden')) {
        selected.addClass('selected').next('div.sub-menu-block').removeClass('is-hidden');
      } else {
        selected.removeClass('selected').next('div.sub-menu-block').addClass('is-hidden');
      }     
      e.preventDefault();
    }).mouseleave(function(e) {
      var selected = $(this);
      if (selected.next('div.sub-menu-block').hasClass('is-hidden')) {
        selected.addClass('selected').next('div.sub-menu-block').removeClass('is-hidden');
      } else {
        selected.removeClass('selected').next('div.sub-menu-block').addClass('is-hidden');
      }
      e.preventDefault();
    });
   
  }

});

// TRIGGER MENU FOR BOTH CASES

function mobileTrigger(){
  $('.menu-trigger').on('click', function(event) {    
    $('body').find('.mobile-menu').addClass('nav-is-visible');       
    $('body').find('.mobile-menu-overlay').addClass('is-visible');        
    $('body').addClass('nav-is-visible');
    $("ul.dt-sc-list-inline.dt-desktop-menu:nth-child(2)").remove();         
  });
}

function closeMobNav() {
  $('body').removeClass('nav-is-visible');
  $('.mobile-menu-overlay').removeClass('is-visible');
  $('.mobile-menu').removeClass('nav-is-visible');
  $('.menu-item-has-children a').removeClass('selected');
  $('.menu-item-has-children div.sub-menu-block').addClass('is-hidden');
}

$(window).on('resize',function() {
  mobileTrigger();
  closeMobNav();
});


$(window).on('load',function() {
  
    function megaMenu() {
      
      if($(".header.full-width").length) {  
        var parentRow = $(".header-wrapper .header");
        var parentLeft = parseInt(parentRow.css("marginLeft").replace('px', ''));    
        var parentPaddingLeft = parseInt(parentRow.css("padding-left").replace('px', ''));        
        parentLeft = parentLeft+parentPaddingLeft;
      } 
      else {
        var parentRow = $(".header-wrapper .header");
        var parentLeft = parseInt(parentRow.offset().left);
        var parentPaddingLeft = parseInt(parentRow.css("padding-left").replace('px', ''));        
        parentLeft = parentLeft+parentPaddingLeft;
      }

      var parentWidth = parentRow.width(); 
           

      $("header .dt-nav li.top-level-link").each(function() {        
        var thisItem = $(this);
        if(thisItem.hasClass('has-mega-menu')) {
          var thisItemLeft = thisItem.find('a').offset().left;
          if(thisItem.parents('.heeader').hasClass('full-width')) {
          	var thisItemMarginLeft = 0;
          } else {
            var thisItemMarginLeft = parseInt(thisItem.find('a').css("marginLeft").replace('px', ''));
          }
          thisItemLeft = thisItemLeft-thisItemMarginLeft;
          var menuLeft = parseInt(thisItemLeft-parentLeft);   
          thisItem.find('.sub-menu-block').css('width', parentWidth);  
          thisItem.find('.sub-menu-block').css('left', -menuLeft);            
        }
      });

      $("#header .sticky-header-active .dt-nav li:not(.close-nav)").each(function() {        
        var thisItem = $(this);
        if(thisItem.hasClass('has-mega-menu')) {
          var thisItemLeft = thisItem.find('a').offset().left;
          var menuLeft = parseInt(thisItemLeft-parentLeft);              
          thisItem.find('.sub-menu-block').css('width', parentWidth);  
          thisItem.find('.sub-menu-block').css('left', -menuLeft);            
        }
      });

    }
  
  window.setTimeout(function(){         
    megaMenu();
  }, 800);
  
});